import React from 'react'
import GoogleLogin from 'react-google-login'
import google from 'images/svg/google_btn.svg'
import { css } from 'react-emotion'
import get from 'lodash.get'

const socialBtn = css({
  cursor: 'pointer',
})
class GoogleLoginFrame extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      googleLoginDisabled: false,
      error: null,
    }
  }

  responseGoogle = response => {
    const google_token = get(response, ['tokenId'], undefined)
    if (google_token) {
      window.parent.postMessage(JSON.stringify(google_token), '*')
    } else {
      window.parent.postMessage('error', '*')
    }
  }

  handleGoogleLoginFailure = ({ error, details }) => {
    console.log('Google Login Failure', error, details)

    if ('idpiframe_initialization_failed' === error) {
      this.setState({ googleLoginDisabled: true })
    }
  }

  render() {
    return (
      <GoogleLogin
        clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
        disabled={this.state.googleLoginDisabled}
        buttonText="Login"
        onSuccess={this.responseGoogle}
        onFailure={this.handleGoogleLoginFailure}
        render={renderProps => (
          <div className={socialBtn} onClick={renderProps.onClick}>
            <img src={google} alt={'google'} />
          </div>
        )}
      />
    )
  }
}
export default GoogleLoginFrame



// WEBPACK FOOTER //
// ./src/features/authentication/components/GoogleLogin.js